import { languages } from './i18n-constants'

export default {
	// This is the list of languages your application supports
	supportedLngs: languages as unknown as string[],
	// This is the language you want to use in case
	// if the user language is not in the supportedLngs
	fallbackLng: 'nl',
	// The default namespace of i18next is "translation", but you can customize it here
	defaultNS: 'common',
	// Disabling suspense is recommended
	react: { useSuspense: false },
}
